import React, { useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import DarkModeIcon from '@mui/icons-material/DarkMode'
import LightModeIcon from '@mui/icons-material/LightMode'
import MenuIcon from '@mui/icons-material/Menu'
import './LandingPageHeader.css'
import cnergiLogo from '../resources/CNERGI_PNG@4x.png'
import { PrimaryButton } from './Buttons'

function LandingPageHeader({ isDarkMode = false, onToggleTheme }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const closeMenu = () => setIsMenuOpen(false)

  return (
    <header className="landing-header">
      <a className="landing-header__brand" href="/" aria-label="CNERGI home">
        <img className="landing-header__logo" src={cnergiLogo} alt="CNERGI" />
        <span className="landing-header__tagline">Intelligent Energy. Visible Impact.</span>
      </a>

      <nav
        id="primary-navigation"
        className={`landing-header__nav ${isMenuOpen ? 'landing-header__nav--open' : ''}`}
        aria-label="Primary navigation"
      >
        <a href="#home" onClick={closeMenu}>Home</a>
        <a href="#solutions" onClick={closeMenu}>Solutions</a>
        <a href="#about" onClick={closeMenu}>About</a>
        <a href="#contact" onClick={closeMenu}>Contact</a>
        <PrimaryButton href="/login" onClick={closeMenu}>Get Started</PrimaryButton>
      </nav>

      <button
        className="landing-header__theme-toggle"
        type="button"
        aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        onClick={onToggleTheme}
      >
        {isDarkMode ? <LightModeIcon aria-hidden="true" /> : <DarkModeIcon aria-hidden="true" />}
        <span>{isDarkMode ? 'Light' : 'Dark'}</span>
      </button>

      <button
        className="landing-header__menu-toggle"
        type="button"
        aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
        aria-controls="primary-navigation"
        aria-expanded={isMenuOpen}
        onClick={() => setIsMenuOpen((current) => !current)}
      >
        {isMenuOpen ? <CloseIcon aria-hidden="true" /> : <MenuIcon aria-hidden="true" />}
      </button>
    </header>
  )
}

export default LandingPageHeader
